import { useTranslation } from "@client-app/i18n";
import { Storefront } from "@phosphor-icons/react";
import { useEffect, useMemo } from "react";
import { useBrandPrototype } from "../../contexts/BrandPrototypeContext";
import { useBrandGroup } from "../../contexts/BrandGroupContext";

const BrandAgentScopeSelector = () => {
  const { t } = useTranslation();
  const { data, selectAgentBrand } = useBrandPrototype();
  const { data: projectData } = useBrandGroup();
  const projects = projectData.brands;
  const activeBrand = projects.find(
    (brand) => brand.id === data.activeAgentBrandId,
  );
  const defaultProject = projects.find((project) => project.isDefault) || projects[0];

  useEffect(() => {
    if (!activeBrand && defaultProject) {
      selectAgentBrand(defaultProject.id);
    }
  }, [activeBrand, defaultProject, selectAgentBrand]);

  const activeScope = activeBrand?.id || defaultProject?.id || "";
  const connectionCount = useMemo(
    () =>
      activeBrand
        ? projectData.connections.filter((connection) =>
            connection.brandIds.includes(activeBrand.id),
          ).length
        : 0,
    [activeBrand, projectData.connections],
  );

  return (
    <div className="mb-2 flex items-center justify-between gap-3 rounded-xl border border-[#E8EBF3] bg-[#F8F9FC] px-3 py-2">
      <div className="flex min-w-0 items-center gap-2">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[9px] bg-white text-[#666F8D] shadow-[inset_0_0_0_1px_#E8EBF3]">
          <Storefront size={17} />
        </div>
        <div className="min-w-0">
          <p className="text-[10px] font-medium uppercase tracking-[0.08em] text-[#8A93B2]">
            {t("website.brandsSettings.crossModule.agentScopeLabel")}
          </p>
          <select
            value={activeScope}
            onChange={(event) => selectAgentBrand(event.target.value)}
            aria-label={t("website.brandsSettings.crossModule.agentScopeLabel")}
            className="-ml-1 max-w-[190px] cursor-pointer bg-transparent pr-2 text-sm font-medium text-[#1A162F] outline-none"
          >
            {projects.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div
        className="shrink-0 text-right"
        title={t("website.brandsSettings.crossModule.agentScopeHint")}
      >
        <p className="text-xs font-medium text-[#3D394D]">
          {t("website.brandsSettings.crossModule.agentScopeConnections", {
            count: connectionCount,
          })}
        </p>
      </div>
    </div>
  );
};

export default BrandAgentScopeSelector;
